import React, {Component} from "react";
import './index.css';
import Resource from "../../Resource";
import moment from "jalali-moment";
import {Link} from "react-router-dom";
import {connect} from 'react-redux';
import {toggleSidebar} from "../../Redux/Actions/sidebar";
import ModalTutorial from "../Modal/ModalTutorial";
import Perms from '../../Perms';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            support: false,
            fullscreen: false,
            installEvent: null,
            root: document.getElementById("root")
        };

        this.ref = {
            modalTutorial: React.createRef()
        };
    }

    componentDidMount() {
        window.addEventListener("beforeinstallprompt", this.appInstallHandler.bind(this));

        this.state.root.addEventListener('fullscreenchange', e => {
            this.setState({fullscreen: Boolean(document.fullscreenElement)});
        });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.installEvent !== nextState.installEvent ||
            this.state.support !== nextState.support ||
            this.state.fullscreen !== nextState.fullscreen ||
            this.props.user !== nextProps.user ||
            this.props.notifies !== nextProps.notifies;
    }

    render() {
        let notifies = this.props.notifies || {};

        return <header>
            <div className="head-menu">
                <img src={Resource.IMAGE.PACK.MENU3} className="menu-icon" alt="menu button" id="menu" onClick={this.props.toggleSidebar}/>
                <Link to={Resource.ROUTE.HOME}>
                    <img src={Resource.IMAGE.LOGO} className="menu-logo dis-3x-n" alt="website logo"/>
                </Link>
            </div>
            {Perms().DASHBOARD.TRACK_PRODUCT && <button className={'button dis-3x-n'} id={'track'}><Link to={Resource.ROUTE.TRACK_PRODUCT}>ردیابی فرآورده</Link></button>}
            {window.ENV?.MULTIMEDIA ? <button className={'button dis-4x-n'} id={'help'} onClick={this.tutorialClickHandler.bind(this)}>فایل‌های آموزشی</button> : null}
            <div className="flex">
                {/*<div className="head-search dis-3x-n">*/}
                {/*    <div className="dis-f">*/}
                {/*        <input type="text" className="head-search-input only-text" placeholder="جستجو"/>*/}
                {/*        <button className="head-search-button">*/}
                {/*            <img src={Resource.IMAGE.SEARCH} alt=""/>*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*    <ul className="head-search-items"></ul>*/}
                {/*</div>*/}
            </div>
            {this.state.installEvent ? <img className={'head-button'} src={Resource.IMAGE.PACK.DOWNLOAD1.BLACK} alt="" onClick={this.installClickHandler.bind(this)}/> : null}
            {window.ENV.SUPPORT && <img className={`head-button ${this.state.support ? 'highlight' : ''}`} src={Resource.IMAGE.PACK.HEADPHONES} alt="" onClick={this.supportClickHandler.bind(this)}/>}
            <img className={'head-button'} src={this.state.fullscreen ? Resource.IMAGE.PACK.MINIMIZE : Resource.IMAGE.PACK.EXPAND} alt="" onClick={this.fullscreenClickHandler.bind(this)}/>
            <div className={`head-state ${this.props.onlineSocket ? 'online' : ''} ${notifies.all ? 'notify' : ''}`} notify={notifies.all || 0}>
                <span className="dis-2x-n">{moment().format('dddd jDD jMMMM')}</span>
                <img src={Resource.IMAGE.USER} alt=""/>
                <div className="head-state-block">
                    <div className={'tags'}>
                        {/*{notifies?.AwaitingSectionNormRequest && <div className={'tag'} style={{color: 'var(--goo-red)'}}><Link to={Resource.ROUTE.HOSPITAL.NORM_REQUESTS + Resource.HASH.AWAITING_HOSPITAL_NORM_REQUESTS}>درخواست فرآورده عادی دارید.</Link></div>}*/}
                        {/*{notifies?.AwaitingSectionEmgRequest && <div className={'tag'} style={{color: 'var(--goo-red)'}}><Link to={Resource.ROUTE.HOSPITAL.NORM_REQUESTS + Resource.HASH.AWAITING_HOSPITAL_EMER_REQUESTS}>درخواست فرآورده اورژانسی دارید.</Link></div>}*/}
                        {/*{notifies?.AwaitingHospitalEmgRequest && <div className={'tag'} style={{color: 'var(--goo-red)'}}><Link to={Resource.ROUTE.HOSPITAL.SECTION_ACCEPTED_REQUEST + Resource.HASH.AWAITING_HOSPITAL_EMER_REQUESTS}>درخواست فرآورده اورژانسی دارید.</Link></div>}*/}
                        <div className={'tag'}><span>بیمارستان:</span> {this.props.user?.hospitalFullName}</div>
                        {this.props.user?.sectionId && <div className={'tag'}><span>بخش:</span> {this.props.user?.sectionName}</div>}
                        <div className={'tag'}><span>کاربر:</span> {this.props.user?.userFullName}</div>
                        <div className={'tag'}><span>زمان ورود: </span>{moment(this.props.user?.login_at || undefined).format('jDD jMMM jYYYY ساعت HH:mm')}</div>
                    </div>
                    <ul className="head-state-menu">
                        {this.props.onlineSocket ?
                            <li style={{color: 'var(--goo-gre)'}}>آنلاین</li> :
                            <li style={{color: 'var(--goo-red)'}}>آفلاین</li>}
                        <li className={'flex'}/>
                        <li><Link to={Resource.ROUTE.SETTINGS}>تنظیمات</Link></li>
                        <li><Link to={Resource.ROUTE.LOGOUT}>خروج</Link></li>
                    </ul>
                </div>
            </div>
            <embed className={`Header-support ${this.state.support ? '' : 'hide'}`} src={'/raychat.html'}/>
            <ModalTutorial ref={this.ref.modalTutorial}/>
        </header>;
    }

    appInstallHandler(event) {
        event.preventDefault();

        this.setState({installEvent: event});
    }

    fullscreenClickHandler() {
        if (this.state.fullscreen) {
            document.exitFullscreen();
        } else {
            if (this.state.root.requestFullscreen) {
                this.state.root.requestFullscreen();
            } else if (this.state.root.mozRequestFullScreen) { /* Firefox */
                this.state.root.mozRequestFullScreen();
            } else if (this.state.root.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                this.state.root.webkitRequestFullscreen();
            } else if (this.state.root.msRequestFullscreen) { /* IE/Edge */
                this.state.root.msRequestFullscreen();
            }
        }
    }

    installClickHandler() {
        this.state.installEvent.prompt();
    }

    supportClickHandler() {
        this.setState({support: !this.state.support});
    }

    tutorialClickHandler() {
        this.ref.modalTutorial.current.open();
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        onlineSocket: state.base.onlineSocket,
        notifies: state.base.notifies
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggleSidebar: _ => dispatch(toggleSidebar())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);